import React, { useState } from "react";
import LEAPColour from "../assets/images/LEAP_Colour.svg";
import Close from "../assets/images/X.svg";

import { useSelector } from "react-redux";
import Spinner from "./Spinner";
function ConfirmationBooking({ onClick, bookingsByDate, date }) {
  const [isCloseLoaded, setIsCloseLoaded] = useState(false);
  const [isLogoLoaded, setIsLogoLoaded] = useState(false);

  const { categories } = useSelector((state) => state.categoriesAfterBooking);

  const { details } = useSelector((state) => state.toursDetailsAfterBooking);

  const booking = bookingsByDate?.[date];
  const items = booking?.filter((item) => item?.items.length);

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute] = time24.split(":");
    const hours = parseInt(hour, 10);
    const suffix = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${minute} ${suffix}`;
  };

  return (
    <div className="leap-h-full !leap-relative leap-mx-auto leap-w-[35rem]">
      <div
        className="!leap-absolute leap-p-5 leap-rounded-xl leap-bg-white leap-w-[86%] leap-h-[90%] leap-top-1/2 leap-left-1/2 leap-transform leap--translate-x-1/2 leap--translate-y-1/2"
        style={{
          background:
            "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)",
        }}
      >
        <div className="leap-absolute  leap-overflow-auto leap-p-5 leap-rounded-xl leap-bg-white leap-w-[98%] leap-h-[99%] leap-top-1/2 leap-left-1/2 leap-transform leap--translate-x-1/2 leap--translate-y-1/2">
          <img
            src={LEAPColour}
            alt="LEAPColour"
            className="leap-mx-auto leap-mt-9"
            loading="lazy"
            onLoad={() => setIsLogoLoaded(true)}
          />

          {isCloseLoaded && isLogoLoaded ? (
            <>
              <div className="">
                <h1 className="leap-uppercase leap-bg-clip-text leap-text-center leap-bg-[linear-gradient(180deg,_#EB3DF7_0%,_#3B29AB_50%,_#73FAFD_100%)] leap-text-5xl leap-font-bold leap-mt-6 leap-text-transparent">
                  TOUR
                </h1>
                <h1 className="custom-gradient-border  leap-relative leap-text-[25px] md:leap-text-[45px] leap-font-bold  leap-text-center leap-uppercase leap-text-white">
                  Confirmed
                </h1>
              </div>
              <div className="leap-mt-12 leap-flex leap-flex-col leap-justify-center leap-items-center">
                {items?.map((attendance, index) => {
                  return (
                    <React.Fragment key={index}>
                      <img
                        src={attendance.qr_image}
                        alt="QR"
                        className="leap-mx-auto leap-mt-3 leap-mb-9 leap-w-[200px] md:leap-w-[250px] lg:leap-w-[300px]"
                        loading="lazy"
                      />
                      {attendance?.items?.map((tour) => (
                        <div className="leap-min-w-[130px] leap-flex leap-flex-col leap-text-center leap-gap-3 leap-justify-center">
                          <span className="leap-text-[#3B29AB] leap-font-bold leap-text-base leap-uppercase">
                            {categories?.data?.find(
                              (cat) => cat?.id == tour?.category_ids
                            )?.title || "Category Not Found"}
                          </span>
                          <span className="leap-text-[#73FAFD] leap-font-bold leap-text-base leap-uppercase">
                            {details?.data?.find(
                              (name) => name?.id == tour?.tour_id
                            )?.name || "Category Not Found"}
                          </span>
                          <span className="leap-font-semibold">
                            {tour?.start_time}
                            <span className="leap-mx-2">to</span>
                            {tour?.end_time}
                          </span>

                          {attendance?.items?.length > 1 && (
                            <div className="leap-w-[20vh] leap-mt-3 leap-mb-6 leap-h-[1px] leap-bg-gradient-to-r leap-from-[#EB3DF7] leap-via-[#3B29AB] leap-to-[#73FAFD] leap-mx-auto"></div>
                          )}
                        </div>
                      ))}
                    </React.Fragment>
                  );
                })}
              </div>{" "}
            </>
          ) : (
            <div className="leap-my-auto leap-flex leap-flex-col leap-justify-center leap-items-center leap-h-full">
              <Spinner />
            </div>
          )}
        </div>
        <button className="" onClick={onClick}>
          <img
            src={Close}
            alt="Close"
            className="leap-absolute  leap-top-[20px]  leap-left-[25px]"
            loading="lazy"
            onLoad={() => setIsCloseLoaded(true)}
          />
        </button>
      </div>
    </div>
  );
}

export default ConfirmationBooking;
